module.exports = __webpack_public_path__ + "bin/b84a2a260d3418f81103eeb7322a8151.jpg";